import type { VisualMediaFile } from "domains/visualMediaPlayer/types";

export enum VisualMediaPlayerTypes {
  SET = "[Visual Media player] - SET",
}

export type SetVisualMediaPlayerAction = { meta?: VisualMediaFile; type: VisualMediaPlayerTypes.SET };
